import { Component, OnInit, Inject } from '@angular/core';
import { SaletrackingInfo } from '../model/saletracking.model';
import { ProjectSaleInfo } from '../model/projectsale.model';

import { Observable } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-saletracking-management',
  templateUrl: './saletracking-management.component.html',
  styleUrls: ['./saletracking-management.component.css']
})
export class SaletrackingManagementComponent implements OnInit {

  form: FormGroup;
  public body: string;
  ProjectSaleList: ProjectSaleInfo[]

  SaletrackingListPromise: Promise<SaletrackingInfo[]>
  SaletrackingList: SaletrackingInfo[]
  SaletrackingListPromisereturn: Promise<SaletrackingInfo[]>[]
  SaleTrackingProcessList: LookupInfo[]

  hidSaletrackingId: number

  ActionPlan: string
  public currentPageNumber: number
  public totalPages: number
  ProjectTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  _ParamProjectSaleID: string

  element: HTMLElement;
  public hidcouchk: number;
  baseurl: string;

  getreturn: Promise<string>;


  ProjectSaleCode: string;
  ProjectSaleName: string;
  ProjectSaleCompanyDisplay: string;
  ProjectSaleContactPerson: string;
  ProjectSaleStatusDisplay: string;
  ProjectSaleCreateBy: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }


  ngOnInit() {
    this.ActionPlan = "";
    this.router.params.subscribe(params => {
      this._ParamProjectSaleID = params['ProjectSaleID'];
    });

    this.loadProjectSale().then((data) => {
      this.ProjectSaleList = data;

      if (this.ProjectSaleList.length) {
        this.ProjectSaleCode = this.ProjectSaleList[0].ProjectSaleCode.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        this.ProjectSaleName = this.ProjectSaleList[0].ProjectSaleName.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        this.ProjectSaleCompanyDisplay = this.ProjectSaleList[0].ProjectSaleCompanyDisplay.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        this.ProjectSaleContactPerson = this.ProjectSaleList[0].ProjectSaleContactPerson.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        this.ProjectSaleStatusDisplay = this.ProjectSaleList[0].ProjectSaleStatusDisplay.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        this.ProjectSaleCreateBy = this.ProjectSaleList[0].ProjectSaleCreateBy.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
      }

    });

    this.form = this.formBuilder.group({
      SaleTrackingSubject: [null, Validators.required],
      SaleTrackingActionPlan: [null, Validators.required],
      SaleTrackingProcess: [null, Validators.required],
      SaleTrackingRemark: [null],
    });

    this.Clearinput();

    this.loadProcess().then((data) => {
      this.SaleTrackingProcessList = data;
    });

    this.LoadSaletracking();

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }



  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  Clearinput() {
    this.form.patchValue({
      SaleTrackingSubject:  "",
      SaleTrackingActionPlan:  "",
      SaleTrackingProcess:  "",
      SaleTrackingRemark: "",
    });

    this.ActionPlan = "";
  }

  LoadSaletracking() {
    this.LoadSaletrackingList();
  }

  async LoadSaletrackingList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['SaleTrackingProjectSaleId'] = parseInt(this._ParamProjectSaleID);



      objectjson['SaleTrackingFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);


      this.httpClient.post<SaletrackingInfo[]>(this.baseurl + "SaleTracking/GetSaleTracking", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaletrackingList = data
          this.hidcouchk = data.length;

        })

    }
  }

  async btnClick_submitInsertSaleTracking() {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        this.OnCreating('y');

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['SaleTrackingProjectSaleId'] = parseInt(this._ParamProjectSaleID);
        objectjson['SaleTrackingSubject'] = this.checkUndefinedString(this.form.controls['SaleTrackingSubject'].value);
        objectjson['SaleTrackingActionPlan'] = this.checkUndefinedString(this.form.controls['SaleTrackingActionPlan'].value);
        objectjson['SaleTrackingProcess'] = this.checkUndefinedString(this.form.controls['SaleTrackingProcess'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['SaleTrackingProcess'].value)) : 0;
        objectjson['SaleTrackingRemark'] = this.checkUndefinedString(this.form.controls['SaleTrackingRemark'].value);
        objectjson['SaleTrackingCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['SaleTrackingFlagDelete'] = "N";


        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<SaletrackingInfo[]>(this.baseurl + "SaleTracking/InsertSaleTracking", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.LoadSaletracking();

            });
      }
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  btnClick_onUpdateSaleTracking(id) {
    this.form.reset();
    $('#ModalSaleTracking').modal('hide');
    this.isOnUpdate = true

    let index = this.SaletrackingList.findIndex(x => x.SaleTrackingId == id);

    this.form.patchValue({
      SaleTrackingSubject: this.SaletrackingList[index].SaleTrackingSubject != null ? this.SaletrackingList[index].SaleTrackingSubject : null,
      SaleTrackingActionPlan: this.SaletrackingList[index].SaleTrackingActionPlan != null ? this.SaletrackingList[index].SaleTrackingActionPlan : null,
      SaleTrackingProcess: this.SaletrackingList[index].SaleTrackingProcess != null ? this.SaletrackingList[index].SaleTrackingProcess : null,
      SaleTrackingRemark: this.SaletrackingList[index].SaleTrackingRemark != null ? this.SaletrackingList[index].SaleTrackingRemark : null,
    });

    this.hidSaletrackingId = this.SaletrackingList[index].SaleTrackingId

    $('#ModalSaleTracking').modal();

  }

  async btnClick_submitUpdateSaleTracking(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');

        id = this.hidSaletrackingId

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };



        var objectjson = {};
        objectjson['SaleTrackingId'] = id;
        objectjson['SaleTrackingSubject'] = this.checkUndefinedString(this.form.controls['SaleTrackingSubject'].value);
        objectjson['SaleTrackingActionPlan'] = this.checkUndefinedString(this.form.controls['SaleTrackingActionPlan'].value);
        objectjson['SaleTrackingProcess'] = this.checkUndefinedString(this.form.controls['SaleTrackingProcess'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['SaleTrackingProcess'].value)) : 0;
        objectjson['SaleTrackingRemark'] = this.checkUndefinedString(this.form.controls['SaleTrackingRemark'].value);
        objectjson['SaleTrackingUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['SaleTrackingFlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<SaletrackingInfo[]>(this.baseurl + "SaleTracking/UpdateSaleTracking", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();

              this.LoadSaletracking();
            });
      }
    } else {
      this.validateAllFormFields(this.form);
    }



  }

  btnClick_deleteSaleTracking(id, auth_token): Observable<SaletrackingInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['SaleTrackingId'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<SaletrackingInfo[]>(this.baseurl + "SaleTracking/DeleteSaleTracking", strjsonCusInfo, httpOptions);

  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxSaleTracking"]').prop('checked', check);

  }

  async btnClick_deleteSaleTrackingitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteSaleTracking(parseInt(id), auth_token).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.LoadSaletracking();
            }
          );
      }
    }

  }

  async btnClick_onDeleteSaleTrackingList() {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedSaleTracking = $('[name="checkboxSaleTracking"]:checked');

        let num = checkkedSaleTracking.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var SaleTrackingcurrent = <HTMLInputElement>checkkedSaleTracking[i];
          observableBatch.push(this.btnClick_deleteSaleTracking(parseInt(SaleTrackingcurrent.value), auth_token).toPromise().then(val => {
          }));

        }

        Promise.all(observableBatch).then(val => {
          console.log('สำเร็จ');
          $('#ModalDeleteComplate').modal('show');
          this.LoadSaletracking();
        });
      }
    }

  }


  btnClick_onCreateSaleTracking() {
    this.form.reset();
    $('#ModalSaleTracking').modal('show');
    this.Clearinput();
    this.isOnUpdate = false

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitSaleTracking").hide();
    
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitSaleTracking").show();
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalSaleTracking').modal('hide');
    }

  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitSaleTracking").hide();
     
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitSaleTracking").show();
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalSaleTracking').modal('hide');
    }

  }

  async loadProcess() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString('SALETRACKINGPROCESS');

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadProjectSale() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = parseInt(this._ParamProjectSaleID);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise();
    }
  }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  GetDateNow(): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "July", "August", "Sep", "Oct", "Nov", "Dec"
    ];

    const d = new Date();

    return d.getDate().toString() + "-" + monthNames[d.getMonth()].toString() + "-" + d.getFullYear().toString() + " " + d.getHours() + ":" + d.getMinutes();

  }

  stripHtml(html) {
  let tmp = document.createElement("DIV");
    tmp.innerHTML = html.replaceAll('<br>','&#013;');
  return tmp.textContent || tmp.innerText || "";
  }

   ConvertDate(DateValue) {
  if (DateValue) {
   
    var date = new Date(DateValue);
    var dayname = date.getDay();
    var day = date.getDate();
    var daystr = '';
    if (day < 10) {
      daystr = '0' + day
    } else {
      daystr = day.toString();
    }

    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var Hours = date.getHours();
    var Minutes = date.getMinutes();

    var Datenow = '';

    Datenow = monthIndex + 1 + "/" + daystr + "/" + year;
  }
  else {

    Datenow = null;
  }

  return Datenow;

}

}
